<ntv-modal
    [isVisible]="isVisible()"
    (modalClose)="onClose()"
    [closeOnBackdrop]="false"
    size="medium"
    modalHeight="auto"
    [showHeader]="false"
    [showFooter]="false">
    <div class="assign-modal" data-testid="assign-license-modal">
        <div class="assign-modal__header">
            <div>
                <h2 class="assign-modal__title">Assign License</h2>
                <p class="assign-modal__subtitle">
                    Search and select a license to assign to this playlist.
                </p>
            </div>
            <button class="assign-modal__close" (click)="onClose()">&#x2715;</button>
        </div>

        <div class="assign-modal__body">
            <div class="assign-modal__field">
                <label class="assign-modal__label">Select License</label>
                <app-autocomplete
                    [options]="licenseOptions()"
                    [config]="autocompleteConfig"
                    [loading]="isLoadingLicenses()"
                    [loadingMore]="isLoadingMore()"
                    [(selectedOptions)]="selectedLicenseOptions"
                    (onSelect)="onLicenseChange($event)"
                    (onSearch)="onSearch($event)"
                    (onScrollEnd)="onScrollEnd()" />
            </div>
        </div>

        <div class="assign-modal__footer">
            <ntv-button
                color="custom"
                customColor="#8DCB2C"
                size="xl"
                rounded="md"
                [disabled]="!isFormValid || isAssigning()"
                [loading]="isAssigning()"
                (buttonClick)="onAssign()">
                <div class="assign-modal__btn-content text-white">
                    <span>Assign License</span>
                    <svg width="14" height="14">
                        <use href="assets/icons/icons-sprite.svg#licenses"></use>
                    </svg>
                </div>
            </ntv-button>
        </div>
    </div>
</ntv-modal>
